import React, { Component } from 'react'
import ModalBody from '../modalbody';
import BookingInput from './bookinginput';
import { connect } from 'react-redux';
import {updateProfile, closeModal, addToast} from "../../actions/index";
import ButtonLoader from '../btnloader';
import { saveLocalState, ajaxerrmsg } from '../../actions/http';

class UpdateProfileModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            username: this.props.user.data.username || '',
            email: this.props.user.data.email || '',
            first_name: this.props.user.data.first_name || '',
            username_err: '',
            email_err: '',
            first_name_err: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e){
        let {value, name} = e.target;
        this.setState({
            [name]: value,
            [name + "_err"]: ''
        })
    }

    handleSubmit(e){
        e.preventDefault();
        let {username, first_name, email} = this.state;
        let postData = new FormData();
        postData.append("username", username);
        postData.append("first_name", first_name);
        postData.append("email", email);
        this.props.updateProfile(postData);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.user.data && nextProps.user.data.is_profile){
            saveLocalState(nextProps.user.data);
            nextProps.closeModal();
        }
        if(nextProps.user.update_profile_error && !this.props.user.update_profile_error){
            nextProps.addToast(ajaxerrmsg(ajaxerrmsg.user.update_profile_error) , false);
        }
    }

    render() {
        let {username, username_err, email, email_err, first_name, first_name_err} = this.state;
        return (
            <ModalBody heading="Update Profile">
                <div className="container-fluid">
                <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
                    <div className="row">
                        <BookingInput size={12} type="text" onChange={this.handleChange} value={first_name} err={first_name_err} name="first_name" placeholder="Name *"/>
                        <BookingInput size={12} type="text" onChange={this.handleChange} value={username} err={username_err} name="username" placeholder="Phone Number *"/>
                        <BookingInput size={12} type="text" onChange={this.handleChange} value={email} err={email_err} name="email" placeholder="Email Address *"/>
                    </div>
                    <div className="modalfooter">
                        <button 
                            type='submit'
                            onSubmit={this.handleSubmit}
                            disabled={username && email && first_name && !this.props.user.fetching ? false : true} 
                            className="btn btn-block btn-ouja m-b-5 m-t-10"
                        >
                            {this.props.user.update_profile_fetching ? <ButtonLoader /> : 'Update Profile'}
                        </button>
                    </div>
                </form>
                </div>
            </ModalBody>
        )
    }
}

const mapStateToProps = ({loginReducer}) => ({
    user: loginReducer
})

const mapDispatchToProps = {
    updateProfile,
    closeModal,
    addToast
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfileModal)